import React, { useState } from 'react';

// Dependencies
import cx from 'classnames';

// Shared components
import Icon from 'shared/components/Icon';

// Custom styles
import './styles';

const Tooltip = ({ icon, description, hover = false }) => {
  const [show, setShow] = useState(false);

  return (
    <div className={cx('custom-tooltip', { 'hover-tooltip': hover })}>
      <Icon
        icon={icon}
        onClick={() => {
          if (!hover) setShow((val) => !val);
        }}
        onMouseEnter={() => {
          if (hover) setShow((val) => !val);
        }}
        onMouseLeave={() => {
          if (hover) setShow((val) => !val);
        }}
      />
      <div
        className={cx({ show })}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
};

export default Tooltip;
